<template>
  <!-- <v-app> -->
  <div>
    <!-- <dashboard-core-app-bar /> -->

    <!-- <dashboard-core-drawer /> -->

    <dashboard-core-view />
     <!-- <v-btn
        key="activeFab.icon"
        color="primary"
        fab
        large
        dark
        bottom
        class="v-btn--main mr-5"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn> -->

    <weigh-in-modal />

  <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
      class="v-btn--main mr-5"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="primary"
          dark
          fab
        >
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        small
        color="secondary"
        @click="weighIn"
      >
        <v-icon>mdi-speedometer</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="secondary"        
        :to="{name: 'Add Food'}"
      >
        <v-icon>mdi-nutrition</v-icon>
      </v-btn>
      <!-- <v-btn
        fab
        dark
        small
        color="red"
      >
        <v-icon>mdi-water</v-icon>
      </v-btn> -->
    </v-speed-dial>

  
      <!-- SNACKBARS -->
    <base-material-snackbar
      v-model="snackbarVisible"
      :type="snackbartype"
      top
      center
    >
      <span v-text="snackbarmessage">
      </span>
    </base-material-snackbar>
  </div>

    <!-- <dashboard-core-settings /> -->
  <!-- </v-app> -->
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: 'DashboardIndex',

    components: {
      // DashboardCoreAppBar: () => import('./components/core/AppBar'),
      // DashboardCoreDrawer: () => import('./components/core/Drawer'),
      // DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
      WeighInModal: () => import('@/components/WeighIn'),
      // FoodAddModal: () => import('@/components/FoodAdd'),
    },

    data: () => ({
      expandOnHover: false,
      direction: 'top',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
    }),
    computed: {
      ...mapState('Ui', ['showSnackbar','snackbartype','snackbarmessage', 'drawer']),
      snackbarVisible: {
        get: function() {
          return this.showSnackbar
        },
        set: function() {
        }
      }
    },
    methods: {
      ...mapMutations('Ui', ['setWeighInModal', 'setFoodAddModal', 'set_drawer']),
      addFood() {
        this.setFoodAddModal(true);
      },
      weighIn() {
        this.setWeighInModal(true);
      }
    },
    mounted() {
      this.set_drawer(true)
    }
  }
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  .v-btn--main {
    bottom: 0;
    right: 0;
    position: fixed;
    margin: 0 0 16px 16px;
    z-index: 1000;
  }
  .v-speed-dial {
    position: fixed !important;
  }
</style>